import { MultiSelect } from '@ublique/components/Dropdown'
import { isEmpty } from 'lodash'
import React from 'react'
import UbliqueRow from '@ublique/components/Template/components/Row'
import UbliqueColumn from '@ublique/components/Template/components/Column'
import cn from 'classnames'

import './index.scss'

const StripePageOvsTitle = ({ text, className = '', configMenu }) => {
  return (
    <UbliqueRow className={cn('ublique-row-page-title', className)}>
      <UbliqueColumn sm={4} md={4} lg={9}>
        <h2>{text}</h2>
      </UbliqueColumn>
      {!isEmpty(configMenu) && (
        <UbliqueColumn className='dropdown-column' sm={4} md={4} lg={3}>
          <MultiSelect className='ovs-multiselect' {...configMenu} />
        </UbliqueColumn>
      )}
    </UbliqueRow>
  )
}

export default StripePageOvsTitle
